export enum ApplicationSourceEnum {
  WEB_ORDERING = 1,
  WEB_ORDERING_WHITELABEL = 2,
  WEB_POS = 3,
  WEB_KIOSK = 4,
  UBER = 5,
  JUST_EAT = 6,
  DELIVEROO = 7,
  MOBILE_IOS = 8,
  MOBILE_ANDROID = 9,
  OTHER = 10,
  VIRTUAL_POS = 11,
  WEB_ORDER_AT_TABLE  = 12,
  VECTRON_POS = 13,
  ULTRA_ORDER = 14,
  WEB_ORDER_CATERING = 15,
}
